import React from 'react';
import { FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
import { SOCIAL_LINKS } from '../data/content';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} data-id="element-355" data-mp="lurntrd9hqsj">
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-1.85-2.48V9.78a5.68 5.68 0 1 0 4.94 5.62V8.99a7.3 7.3 0 0 0 4.27 1.38V7.28a4.25 4.25 0 0 1-3.21-1.46Z" data-id="element-356" data-mp="gwgfxm6j1qcy" />
    </svg>;
}
const ICONS: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  Instagram: InstagramIcon,
  TikTok: TikTokIcon,
  YouTube: YoutubeIcon,
  Facebook: FacebookIcon
};
export function SocialLinks() {
  return <div className="mt-16 border-t border-ink/10 pt-10" data-id="element-357" data-mp="zvuc8arqbd6m">
      <p className="text-[11px] uppercase tracking-overline text-walnut" data-id="element-358" data-mp="zt84aa0xevnv">Síguenos</p>
      <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-359" data-mp="1xcjbbwpao1cb">
        {SOCIAL_LINKS.map(social => {
        const Icon = ICONS[social.name];
        return <li key={social.name} data-id="element-360" data-mp="1yj1q0n7u263r">
              <a href={social.url} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 rounded-2xl border border-ink/10 bg-white px-5 py-4 transition-[border-color,background-color,transform] duration-200 ease-premium hover:-translate-y-0.5 hover:border-walnut/50 hover:bg-sand/40" data-id="element-361" data-mp="1yk2zwod44mjw">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ink text-cream transition-colors duration-200 ease-premium group-hover:bg-walnut" data-id="element-362" data-mp="1ftll7np47rhj">
                  <Icon className="h-[18px] w-[18px]" data-id="element-363" data-mp="15uw0ln5u3sxl" />
                </span>
                <span className="flex flex-col" data-id="element-364" data-mp="1asxlmdmtm2bp">
                  <span className="text-[13.5px] font-medium text-ink" data-id="element-365" data-mp="3072mph09nu4o">{social.name}</span>
                  <span className="text-[12px] text-stone-600" data-id="element-366" data-mp="3059dbty9qvsz">{social.handle}</span>
                </span>
              </a>
            </li>;
      })}
      </ul>
    </div>;
}